import { ObjectValues } from "@/src/shared/types/objectValues";

export const SELECTION_DIRECTION = {
  Forward: "forward",
  Backward: "backward",
  None: "none",
} as const;

export type SelectionDirection = ObjectValues<typeof SELECTION_DIRECTION>;
